export { T } from './theme';

export const SIDEBAR_ITEMS = [
  { label: "Dashboard", icon: "grid" },
  { label: "Tickets", icon: "list" },
  { label: "Reports", icon: "chart" },
  { label: "AI Assistant", icon: "star" },
  { label: "Admin", icon: "settings" },
];

export const DEFAULT_WIDGETS = [
  { id: "stats", label: "Key Stats", icon: "📊", span: 3, visible: true },
  { id: "priority", label: "By Priority", icon: "🟢", span: 1, visible: true },
  { id: "status", label: "By Status", icon: "🔵", span: 1, visible: true },
  { id: "trend", label: "Daily Trend", icon: "📈", span: 1, visible: true },
  { id: "activity", label: "Recent Activity", icon: "🕒", span: 2, visible: true },
  { id: "quick", label: "Quick Stats", icon: "⚡", span: 1, visible: true },
];

export const SORT_FIELDS = [
  { key: "subject", label: "Subject" },
  { key: "requester", label: "Requester" },
  { key: "status", label: "Status" },
  { key: "priority", label: "Priority" },
  { key: "dept", label: "Department" },
  { key: "source", label: "Source" },
];

export const EXPORT_FIELDS = [
  { key: "workspace", label: "Workspace" },
  { key: "email", label: "Requester Email" },
  { key: "category", label: "Category" },
  { key: "created", label: "Created Time" },
  { key: "subcategory", label: "Sub-Category" },
  { key: "dueBy", label: "Due by Time" },
  { key: "id", label: "Ticket ID" },
  { key: "requester", label: "Requester" },
  { key: "subject", label: "Subject" },
  { key: "status", label: "Status" },
  { key: "priority", label: "Priority" },
  { key: "assignedTo", label: "Assigned To" },
  { key: "dept", label: "Department" },
  { key: "modified", label: "Last Modified" },
  { key: "state", label: "State" },
];

export const MOCK_AGENTS = [
  { name: "Sriram Senthilkumar", isMe: true },
  { name: "Aldo Cardoso", isMe: false },
  { name: "Damien Phillips", isMe: false },
];

export const MOCK_GROUPS = [
  "First Responders Group",
  "Change Team",
  "Database Team",
  "HR Team",
  "Network Support Team",
  "Salesforce Team",
  "Security Team",
  "DevOps Team"
];

export const GROUP_MEMBERS = {
  "First Responders Group": ["Aldo Cardoso", "Damien Phillips", "Sriram Senthilkumar"],
  "Change Team": ["Jason Mckinney", "Tung Nguyen", "Nadir Salih"],
  "Database Team": ["Priya Kumar", "Joshua Lee", "Ayesha Rizvi"],
  "HR Team": ["Meera Patel", "Ravi Singh", "Lina Joseph"],
  "Network Support Team": ["Kevin Hart", "Sophie Turner", "Nina Gomez"],
  "Salesforce Team": ["Diego Torres", "Amy Chen", "Jules Baker"],
  "Security Team": ["Elena Reed", "Noah Brooks", "Mina Shah"],
  "DevOps Team": ["Liam Turner", "Zara Khan", "Omar Malik"]
};

export const STATUS_OPTIONS = ["Open", "Pending Action", "Pending Approval", "Pending User Acceptance", "Completed", "Rejected", "Voided"];
export const SOURCE_OPTIONS = ["Email", "Phone", "Portal", "Chat", "Walk-in"];
export const TYPE_OPTIONS = ["Incident", "Service Request", "Problem", "Change"];
export const GROUP_OPTIONS = [...MOCK_GROUPS];
